//Company Actions
export const ACTION_COMPANY_ANALYSTS_MODAL_TOGGLE =
  'COMPANY_ANALYSTS_MODAL_TOGGLE';

// Grid View Options
export enum GridViewOptions {
  GRID_VIEW_POTENTIALLY_UNDERVALUED = '16650',
  GRID_VIEW_STRONG_PAST_PERFORMING = '16734',
  GRID_VIEW_HEALTHY = '16735',
  GRID_VIEW_HIGH_GROWTH = '16733',
  GRID_VIEW_DIVIDEND_PAYING = '16736',
  GRID_VIEW_DIVIDEND_NEW = '240709',
}

export const PEERS_LIMIT = 4;

//TODO: @ric use this const to render section reports
export const REPORT_SECTION_TITLE = {
  summary: 'Stock Overview',
  valuation: 'Valuation',
  future: 'Future Growth',
  past: 'Past Earnings Performance',
  health: 'Balance Sheet Health',
  dividend: 'Dividend',
  management: 'Management',
  ownership: 'Ownership',
  information: 'Company Information',
};
